import { cardDebitReducer } from './cardDebitReducer';
import authReducer from '../helper/actions/auth';
import loading from '../helper/actions/loading';

export const Reducers = {
  cardDebitState : cardDebitReducer,
  auth: authReducer,
  loading: loading
};
